const mediaCardConfig = require('@common-vue/media-card-large/config.mcom');
const addToBagConfig = require('./config.mcom.atb');
const addToRegistryConfig = require('./config.mcom.atr');
const ppcConfig = require('./config.mcom.ppc');
const commonCookies = require('./src/constants/cookies');

const CUSTOMER_SERVICE_DOMAIN = 'https://www.customerservice-macys.com';

module.exports = {
  brand: 'mcom',
  brandName: "Macy's",
  marketPlace: {
    phoneNumber: '1-800-289-6229',
    concernReportLink: 'https://survey.medallia.com/?mcy-tuwyt-com',
    faqLink: '',
  },
  storeLocatorParams: { // for nearby stores
    storeLocationType: 'MSTORE', // 'BSTORE' for bcom and default 'UPS'
    divisionNumber: 12, // 12 for Macy's stores and 13 for Bloomingdale's stores,
    page: 'pdp',
  },
  ...addToBagConfig,
  ...addToRegistryConfig,
  ...mediaCardConfig,
  ...ppcConfig,
  denomination: [10, 25, 50, 75, 100, 500],
  customerServiceUrls: {
    bigTicketShipping: {
      international: `${CUSTOMER_SERVICE_DOMAIN}/articles/furniture-mattress-policies`,
      domestic: `${CUSTOMER_SERVICE_DOMAIN}/articles/furniture-mattress-policies`,
    },
    shipping: {
      international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/5363/theme/popup`,
      domestic: `${CUSTOMER_SERVICE_DOMAIN}/articles/what-are-my-delivery-shipping-options-at-macys/`,
    },
    returns: {
      international: `${CUSTOMER_SERVICE_DOMAIN}/app/answers/detail/a_id/5362/theme/popup`,
      domestic: `${CUSTOMER_SERVICE_DOMAIN}/articles/what-is-macys-return-policy/`,
    },
  },
  iconClasses: {
    fullscreen: 'full-screen',
    overlayCarouselLeftArrow: 'chevron-large-left-black',
    overlayCarouselRightArrow: 'chevron-large-right-black',
  },
  cookies: {
    ...commonCookies,
    userId: 'macys_online_uid',
    userGuid: 'macys_online_guid',
    bagGuid: 'macys_bagguid',
  },
  topLevelCategoryID: {
    men: '1',
    women: '118',
    junior: '16904',
    mattresses: '25931',
    comforters: '78458',
  },
};
